export default "__VITE_ASSET__83c66000__"